import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { User, SpiderSchedule} from '../../../_models';
import { AuthenticationService, KeywordService, NotificationService, SpiderService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './spider-schedule-list.component.html' })
export class SpiderScheduleListComponent implements OnInit {
  filterForm: FormGroup;
  newScheduleForm: FormGroup;
  scheduleList: SpiderSchedule[];
  currentUser: User;
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;

  types = [
    {"name":"MO", "value":1},
    {"name":"DN", "value":2},
    {"name":"SUBSCRIBER", "value":3},
  ];
  states = [
    {"name":"WAITING", "value":0},
    {"name":"PROCESSING", "value":1},
    {"name":"SUCCESS", "value":2},
    {"name":"FAIL", "value":-1}
  ];

  filterable = {
    description: '',
    state: -1,
  };

  sourceList = [];
  countryList: any = {};
  shortCodeList = [];

  typeDropdownSettings = {
    singleSelection: false,
    text:"Select Spider Types",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"",
    primaryKey: "value",
    labelKey: "name"
  };

  constructor(private fb: FormBuilder,
    private userSvc: UserService,
    private authSvc: AuthenticationService,
    private keywordSvc: KeywordService,
    private spiderSvc: SpiderService,
    private notification: NotificationService,
    private modalService: NgbModal) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.loadPage(1);
    this.loadSources();
  }

  openModal(targetModal) {
    this.processing = false;
    this.showError = false;

    var source = this.sourceList[0];
    this.countryList = this.sourceList[0].subOptions;
    var key = Object.keys(this.sourceList[0].subOptions)[0];
    let country = this.sourceList[0].subOptions[key];

    let dte = new Date();
    dte.setDate(1);
    var toDay = dte.toISOString().substring(0,10);
    dte.setDate(0);
    dte.setDate(1);
    var startDay = dte.toISOString().substring(0, 10);

    this.newScheduleForm = this.fb.group({
      description: [null, Validators.required],
      source: [source, Validators.required],
      country: [country, Validators.required],
      spiderTypes:[[], Validators.required],
      shortCode: [''],
      startDay: [startDay, Validators.required],
      toDay: [toDay, Validators.required]
    });

    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.changeCountry(country);
  }

  get f() { return this.newScheduleForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear() {
    this.filterable = {
      description: '',
      state: -1,
    };
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onClear() {
    this.newScheduleForm.patchValue({
      shortCode: null
    });
  }

  changeSource(source) {
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      this.newScheduleForm.patchValue({
        country: targetCountry,
      });
    }
  }

  changeCountry(country) {
    this.newScheduleForm.patchValue({
      shortCode: null
    });
    this.shortCodeList = [];
    if (country) {
      this.keywordSvc.getSelectionScKwsLight(this.newScheduleForm.getRawValue()["source"].value, country, "SPIDER").subscribe(data => {
        this.shortCodeList = Object.keys(data.data);
      });
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources("SPIDER").pipe(first()).subscribe(data => {
      this.sourceList = data.data;
    });
  }

  onSubmit() {
    this.processing = true;
    if (this.newScheduleForm.valid) {
      if (confirm("Are you sure to add the schedule now?")) {
        let spiderTypes = [];
        this.newScheduleForm.get("spiderTypes").value.forEach(element => {
          spiderTypes.push(element["value"]);
        });
        let scheduleBody = {
          dataSource: this.newScheduleForm.get("source").value.value,
          countryCode: this.newScheduleForm.get("country").value,
          shortCode: this.newScheduleForm.get("shortCode").value,
          startDay: formatDate(this.newScheduleForm.get("startDay").value, 'yyyyMMdd', 'en'),
          toDay: formatDate(this.newScheduleForm.get("toDay").value, 'yyyyMMdd', 'en'),
          spiderTypes : spiderTypes,
          description: this.newScheduleForm.get("description").value,
        };
        this.spiderSvc.saveSchedule(scheduleBody).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Schedule added successfully!", "New Schedule");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add schedule, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  deleteSchedule(schedule) {
    if (confirm("Are you sure to delete this schedule?")) {
      this.spiderSvc.deleteSchedule(schedule.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Schedule deleted successfully!", "Delete Schedule");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting schedule, please try again later.", "Error");
        }
      })
    }
  }

  restartSchedule(schedule) {
    if (confirm("Are you sure to restart this schedule?")) {
      this.spiderSvc.restartSchedule(schedule.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Schedule restarted successfully!", "Restart Schedule");
          this.loadPage(1);
        } else {
          this.notification.showError("Error restarting schedule, please try again later.", "Error");
        }
      })
    }
  }

  restartAllSchedule() {
    if (confirm("Are you sure to restart all failed schedule?")) {
      this.spiderSvc.restartAllSchedule().subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Schedule restarted successfully!", "Restart Schedule");
          this.loadPage(1);
        } else {
          this.notification.showError("Error restarting schedule, please try again later.", "Error");
        }
      })
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.scheduleList = [];
    let params = this.formParam(page);

    // get page of items from api
    this.spiderSvc.listSchedules(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.scheduleList = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      description: this.filterable.description,
      state: this.filterable.state
    }
    return params;
  }

}
